module.exports = __webpack_public_path__ + "img/9788962631425.e8032b55.jpg";